import { Box } from "@mui/material";
import React from "react";
import Form from "./Form";
import { useSelector } from "react-redux";
import Table from "./Table";
import MultiLineChart from "./MultiLineChart";
import DataExport from "./DataExport";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function Customer() {
  const state = useSelector((store) => store.analyze);
  const { customerTDPrepared, customerMLCDPrepared, clearAnalyzeCustomer } =
    state;
  return (
    <Box sx={{ mt: 2, width: "99%" }}>
      <Form />
      <CollapseSection title=" Analyze Customer">
        {clearAnalyzeCustomer && <DataExport />}
        {customerMLCDPrepared && clearAnalyzeCustomer ? (
          <MultiLineChart />
        ) : null}
      </CollapseSection>
      {customerTDPrepared && clearAnalyzeCustomer ? <Table /> : null}
    </Box>
  );
}
